import { Injectable } from '@angular/core';
import { App, MenuController, Platform } from 'ionic-angular';
import { AnalyticsServiceProvider } from '../analytics-service/analytics-service';

/*
  Generated class for the ViewServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ViewServiceProvider {
  configLoaded = false;

  constructor(private app: App, private analyticsService: AnalyticsServiceProvider, private menuCtrl: MenuController, private platform: Platform) {}

  checkConfigLoaded(state) {
    if (state) {
      // DisplayService.overrideWelcome(state);
    }
    if (!this.configLoaded) {
      state.go('loading');
    }
  }

  setConfigLoaded(loaded) {
    this.configLoaded = loaded;
  }

  disableSideMenu(scope) {
    scope.on('$ionicView.afterEnter', function () {
      this.menuCtrl.canDragContent(false);
    });

    scope.on('$ionicView.beforeLeave', function () {
      this.menuCtrl.canDragContent(true);
    });
  }

  registerBackButton(state, scope) {
    var deregister;
    scope.on('$ionicView.enter', function () {
      deregister = this.platform.registerBackButtonAction((event) => {
        event.preventDefault();
        // StateService.transitionTo(state);
      }, 101);
    });

    scope.on('$ionicView.beforeLeave', function () {
      if (deregister) {
        deregister();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/view-service/view-service.ts